import { RETURN_TYPE } from 'domains/seller-outbound-return/constants'
import * as Yup from 'yup'

// ? Should we move it to the utils?
Yup.addMethod(Yup.array, 'unique', function(message, mapper = (a) => a) {
  return this.test('unique', message, function(list) {
    return list.length  === new Set(list.map(mapper)).size
  })
})

/** Create Outbound return schema */
const sellerOutboundReturnCreateSchema = Yup.object().shape({
  seller_id   : Yup.number().required('Required'),
  return_type : Yup.string().oneOf(
    Object.values(RETURN_TYPE),
    `Must be one of this value: ${Object.values(RETURN_TYPE).join(', ')}`
  ).required('Required'),
  items: Yup.array()
    .of(
      Yup.object().shape({
        sku: Yup.string().required('Required')
      }))
    .unique('Setiap inbound item harus unik', (items) => items.sku)
    .min(1, 'Minimum one item is filled')
    .required('Required')
})

export default sellerOutboundReturnCreateSchema
